import * as React from "react"
import { BREAKPOINTS } from "./breakpoints"

/**
 * Hook to detect if the current viewport is desktop size (≥ 768px)
 * @returns true if viewport width is 768px or larger, false otherwise
 */
export function useDesktop(): boolean {
  const [isDesktop, setIsDesktop] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${BREAKPOINTS.MOBILE}px)`)
    const onChange = () => {
      setIsDesktop(window.innerWidth >= BREAKPOINTS.MOBILE)
    }
    mql.addEventListener("change", onChange)
    setIsDesktop(window.innerWidth >= BREAKPOINTS.MOBILE)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isDesktop
}
